import { render, staticRenderFns } from "./default-form.vue?vue&type=template&id=2c31269b&"
import script from "./default-form.vue?vue&type=script&lang=js&"
export * from "./default-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports